import { createStore } from "vuex";

const state = {
  sidebarShow: "responsive",
  sidebarMinimize: false,
  currentProject: {},
  currentUser: {},
  currentMode: "production",
  alert: {
    show: false,
    color: "dark",
    duration: 2,
    message: "",
  },
};

const mutations = {
  toggleSidebarDesktop(state) {
    const sidebarOpened = [true, "responsive"].includes(state.sidebarShow);
    state.sidebarShow = sidebarOpened ? false : "responsive";
  },
  toggleSidebarMobile(state) {
    const sidebarClosed = [false, "responsive"].includes(state.sidebarShow);
    state.sidebarShow = sidebarClosed ? true : "responsive";
  },
  setAlert(state, config) {
    state.alert = { ...state.alert, ...config, show: true };
  },

  hideAlert() {
    state.alert.show = false;
  },
  set(state, [variable, value]) {
    state[variable] = value;
  },
};

export default createStore({
  state,
  mutations,
});
